import { createContext } from 'react';

import { NotificationsApi } from './types';

export const AntdNotificationsContext = createContext<NotificationsApi | null>(null);
